export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0f1319] border-t border-white/5 py-8 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <a href="https://shipvelocity.com" target="_blank" rel="noopener noreferrer"><img src="/lp/Footerlogo.png" alt="Ship Velocity" className="h-10 w-auto" /></a>
        <div className="flex items-center gap-4 text-[11px] text-white/30">
          <a href="https://shipvelocity.com/cookie-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors">Cookie Policy</a>
          <span>|</span>
          <a href="https://shipvelocity.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors">Privacy Policy</a>
          <span>|</span>
          <a href="https://shipvelocity.com/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors">Terms & Conditions</a>
          <span>|</span>
          <a href="/admin" className="hover:text-white/60 transition-colors">Login</a>
        </div>
        <p className="text-[11px] text-white/20">&copy; 2019 - {new Date().getFullYear()} Velocity Worldwide LLC. All rights reserved.</p>
      </div>
    </footer>
  );
}
